import {
  GET_WORD_PAIR_REQUEST,
  GET_WORD_PAIR_SUCCESS,
  SET_REMEMBERED,
  SET_FORGOTTEN,
} from '../constants';
import { WordPair } from "../models";

export interface IGetWordPairRequest {
  type: typeof GET_WORD_PAIR_REQUEST;
}

export interface ISetRemembered {
  type: typeof SET_REMEMBERED;
}

export interface ISetForgotten {
  type: typeof SET_FORGOTTEN;
}

export interface ISetWordPairAction {
  type: typeof GET_WORD_PAIR_SUCCESS;
  wordPair: WordPair;
}

type ActionTypes = IGetWordPairRequest | ISetWordPairAction | ISetRemembered | ISetForgotten;

const wordPair = (state: WordPair|null = null, action: ActionTypes): WordPair|null => {
  switch (action.type) {
    case GET_WORD_PAIR_SUCCESS:
      return action.wordPair;

    case SET_REMEMBERED:
      if (!state) {
        return null;
      }

      return {
        ...state,
        remembered: 1,
      };

    case SET_FORGOTTEN:
      if (!state) {
        return null;
      }

      return {
        ...state,
        remembered: 0,
      };

    default:
      return state;
  }
};

export default wordPair;
